import React from "react";
import get from "lodash/get";

import { Row, Col, Layout, Alert, Spin } from "antd";

import HomeHeader from "../../components/HomeHeader/HomeHeader";
import Footer from "../../components/Footer/Footer";
import classes from "./Documents.css";

// import PhysicianScript from "../../assets/documents/Physician-Script.pdf";
// import PatientInformationSheetText from "../../assets/documents/Patient-Information-Sheet-Text.pdf";
// import PatientInformationSheetVisual from "../../assets/documents/Patient-Information-Sheet-Visual.pdf";
// import PatientConsentForm from "../../assets/documents/Patient-Consent-Form.pdf";
// import SurrogateConsentForm from "../../assets/documents/Surrogate-Consent-Form.pdf";
// import LetterOfBereavement from "../../assets/documents/Letter-of-Bereavement.docx";
// import SAEForm from "../../assets/documents/AcT-SAE-Report.pdf";
// import TrialProtocol from "../../assets/documents/AcT-trial-protocol.pdf";

import { getPublicDocumentsRequest } from "../../api/requests";
import withTrackerGA from "../../utils/withTrackerGA";
import { withNamespaces } from "react-i18next";

const { Content } = Layout;

class Documents extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      documents: [],
      requestResult: {},
    };
  }

  componentDidMount = async () => {
    this.setState({ isLoading: true });

    try {
      const response = await getPublicDocumentsRequest();
      this.setState({ isLoading: false, documents: get(response, "data") });
    } catch (e) {
      this.setState({
        isLoading: false,
        requestResult: {
          type: "error",
          message: get(e, "response.data.error", "Error"),
        },
      });
    }
  };

  render() {
    const { isLoading, documents, requestResult } = this.state;
    const listItems = documents.map((document) =>
      get(document, "url", "").slice(-4).includes(".mp4") ? (
        <li key={document.name}>
          <video width="100%" height="320px" controls>
            <source src={document.url} type="video/mp4" />
          </video>
        </li>
      ) : (
        <li key={document.name}>
          <a href={document.url} target="_blank">
            {document.name}
          </a>
        </li>
      )
    );
    return (
      <div>
        <HomeHeader />
        <Layout className="front-layout">
          <Content className={classes.content} style={{ marginTop: 0 }}>
            <Row>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 20, offset: 2 }}
                md={{ span: 16, offset: 4 }}
              >
                <Row type="flex" justify="center">
                  <Col
                    xs={24}
                    sm={18}
                    md={18}
                    lg={20}
                    xl={18}
                    className="front-content-wrapper"
                  >
                    <h4>{this.props.i18n.t("Documents")}</h4>
                    <p>
                      {this.props.i18n.t(
                        "NamespaceDocuments:Below is detailed public information about the DCTMS Trial."
                      )}
                    </p>

                    {isLoading && (
                      <Spin
                        tip={this.props.i18n.t("NamespaceDocuments:Loading...")}
                      />
                    )}
                    <ul>{!isLoading && listItems}</ul>

                    {!isLoading && listItems && listItems.length === 0 && (
                      <Alert
                        message={this.props.i18n.t(
                          "NamespaceDocuments:Document list is empty"
                        )}
                        type="warning"
                      />
                    )}

                    <p>&nbsp;</p>
                    {requestResult.type && (
                      <div>
                        <Alert
                          message={requestResult.message}
                          type={requestResult.type}
                          className={classes.submitResult}
                        />
                        <br />
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Content>
          <Footer />
        </Layout>
      </div>
    );
  }
}

export default withTrackerGA(withNamespaces()(Documents));



// WEBPACK FOOTER //
// ./src/containers/Documents/Documents.js